import { render, staticRenderFns } from "./platformParaDialog.vue?vue&type=template&id=4aeec802&"
import script from "./platformParaDialog.vue?vue&type=script&lang=js&"
export * from "./platformParaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports